module.exports = __webpack_public_path__ + "static/media/12.766009d1.png";